import { useState } from "react";
import { Button, Modal } from "@mui/material";
import { toast } from "react-toastify";
import "./AddSiteModal.css";

const LinkModal = ({
  isOpen,
  onClose,
  onConfirm,
  templateOptions,
  dataRecordOptions,
  loadingOptions,
  handleRefreshTag,
}) => {
  const [selectedTemplateId, setSelectedTemplateId] = useState("");
  const [selectedFreeTemplateId, setSelectedFreeTemplateId] = useState("");
  const [selectedBusyTemplateId, setSelectedBusyTemplateId] = useState("");
  const [selectedDataRecordId, setSelectedDataRecordId] = useState("");
  const [askRefresh, setAskRefresh] = useState(false);

  const [roomAssigned, setRoomAssigned] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = () => {
    setAskRefresh(true);
  };

  const handleRefreshChoice = async (refresh) => {
    if (refresh) await handleRefreshTag();
    setAskRefresh(false);
    onClose();
  };

  const validateBeforeSubmit = () => {
    if (roomAssigned) {
      if (!selectedFreeTemplateId || !selectedBusyTemplateId) {
        toast.error("Please select both Free & Busy templates.");
        return false;
      }
    } else {
      if (!selectedTemplateId || !selectedDataRecordId) {
        toast.error("Please select both a template and a data record.");
        return false;
      }
    }
    return true;
  };

  const submitSelection = async () => {
    if (!validateBeforeSubmit()) return false;

    if (roomAssigned) {
      await onConfirm(
        {
          truInkOccupancyFreeTemplate: selectedFreeTemplateId,
          truInkOccupancyBusyTemplate: selectedBusyTemplateId,
        },
        null
      );
      setSelectedFreeTemplateId("");
      setSelectedBusyTemplateId("");
    } else {
      await onConfirm(selectedTemplateId, selectedDataRecordId);
      setSelectedTemplateId("");
      setSelectedDataRecordId("");
    }
    return true;
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="modal-overlay">
        {!askRefresh ? (
          <div className="modal-content">
            <h2 style={{ textAlign: "center", marginBottom: "2rem" }}>
              Link Template & Data
            </h2>

          
            <div className="input-group" style={{ marginBottom: "1.5rem" }}>
              <label>Is this tag assigned to a room?</label>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={roomAssigned}
                  onChange={() => setRoomAssigned(!roomAssigned)}
                />
                <span className="slider round"></span>
              </label>
            </div>

         
            {!roomAssigned ? (
              <>
               
                <div className="input-group">
                  <label>Select a Template:</label>
                  <select
                    value={selectedTemplateId}
                    onChange={(e) => setSelectedTemplateId(e.target.value)}
                    disabled={loadingOptions}
                  >
                    <option value="">None</option>
                    {templateOptions.map((template) => (
                      <option key={template.id} value={template.id}>
                        {template.name}
                      </option>
                    ))}
                  </select>
                </div>

            
                <div className="input-group">
                  <label>Select a Data Record:</label>
                  <select
                    value={selectedDataRecordId}
                    onChange={(e) => setSelectedDataRecordId(e.target.value)}
                    disabled={loadingOptions}
                  >
                    <option value="">None</option>
                    {dataRecordOptions.map((dr) => (
                      <option key={dr.id} value={dr.id}>
                        {dr.identifier || `Record: ${dr.id}`}
                      </option>
                    ))}
                  </select>
                </div>
              </>
            ) : (
              <>
               
                <div className="input-group">
                  <label>Select Free Template:</label>
                  <select
                    value={selectedFreeTemplateId}
                    onChange={(e) => setSelectedFreeTemplateId(e.target.value)}
                    disabled={loadingOptions}
                  >
                    <option value="">None</option>
                    {templateOptions.map((template) => (
                      <option key={template.id} value={template.id}>
                        {template.name}
                      </option>
                    ))}
                  </select>
                </div>

               
                <div className="input-group">
                  <label>Select Busy Template:</label>
                  <select
                    value={selectedBusyTemplateId}
                    onChange={(e) => setSelectedBusyTemplateId(e.target.value)}
                    disabled={loadingOptions}
                  >
                    <option value="">None</option>
                    {templateOptions.map((template) => (
                      <option key={template.id} value={template.id}>
                        {template.name}
                      </option>
                    ))}
                  </select>
                </div>
              </>
            )}

         
            <div className="modal-actions">
              <Button

                onClick={onClose}
                variant="contained"

                sx={{
                  textTransform: "none",
                  background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                  color: "#fff",
                  boxShadow: "none",
                  "&:hover": {
                    background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                    opacity: 0.95,
                    boxShadow: "none"
                  },
                  "&.Mui-disabled": {
                    background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                    opacity: 0.5,
                    color: "#fff"
                  }
                }}

              >
                Cancel
              </Button>
              <Button
                onClick={handleConfirm}
                disabled={loadingOptions}
                variant="contained"
                sx={{
                  textTransform: "none",
                  color: "white",
                  backgroundColor: "rgb(90, 28, 47)",
                  "&:hover": {
                    backgroundColor: "rgb(70, 20, 35)",
                  },
                  "&.Mui-disabled": {
                    backgroundColor: "rgba(90, 28, 47, 0.4)",
                    color: "#fff",
                  },
                }}
              >


                Confirm
              </Button>
            </div>
          </div>
        ) : (
        
          <div
            className="modal-content"
            style={{
              maxWidth: "500px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h3>Confirmation</h3>
            <div style={{ textAlign: "left", marginBottom: "1.5rem" }}>
              You have updated the data binding associated with the tag.
              <br />
              Do you want to refresh the content being displayed on the tag
              right now?
            </div>

            <div className="modal-actions">
              <Button
                variant="contained"
                onClick={async () => {
                  const success = await submitSelection();
                  if (!success) return;
                  handleRefreshChoice(false);
                }}
                sx={{
                  textTransform: "none",
                  background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                  color: "#fff",
                  boxShadow: "none",
                  "&:hover": {
                    background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                    opacity: 0.95,
                    boxShadow: "none"
                  },
                  "&.Mui-disabled": {
                    background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                    opacity: 0.5,
                    color: "#fff"
                  }
                }}
              >
                No
              </Button>

              <Button
                variant="contained"
                onClick={async () => {
                  const success = await submitSelection();
                  if (!success) return;
                  await handleRefreshChoice(true);
                }}
                sx={{
                  textTransform: "none",
                  backgroundColor: "rgb(90, 28, 47)",
                  "&:hover": {
                    backgroundColor: "rgb(70, 20, 35)",
                  },
                  "&.Mui-disabled": {
                    backgroundColor: "rgba(90, 28, 47, 0.4)",
                    color: "#fff",
                  },
                }}

              >
                Yes
              </Button>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default LinkModal;
